module.exports = __webpack_public_path__ + "img/box5.80fc64d0.png";